<template>
  <div class="container-fluid im-fluid" @click="$root.hideMenu">
    <h2 class="im-title">{{ $t("nav.training_program") }}</h2>

    <div class="row">
      <div class="col-12 col-sm-12 col-xl-7 border-right">
        <div class="im-col im-col-1">
          <div class="im-block">
            <p>
              {{ $t("training.intro") }}
            </p>

            <p>
              {{ $t("training.areas_intro") }}
            </p>

            <p>
              <strong>{{ $t("training.general") }}</strong>
            </p>

            <ul>
              <li class="mb-4">
                {{ $t("training.topic_programming_basics") }}
              </li>

              <li class="mb-4">
                {{ $t("training.topic_algorithms") }}
              </li>

              <li class="mb-4">
                {{ $t("training.topic_algorithm_analysis") }}
              </li>

              <li class="mb-4">
                {{ $t("training.topic_oop") }}
              </li>

              <li class="mb-4">
                {{ $t("training.topic_clean_code") }}
              </li>

              <li class="mb-4">
                {{ $t("training.topic_testing") }}
              </li>

              <li class="mb-4">
                {{ $t("training.topic_refactoring") }}
              </li>

              <li class="mb-4">
                {{ $t("training.topic_functional") }}
              </li>

              <li class="mb-4">
                {{ $t("training.topic_tools") }}
              </li>

              <li class="mb-4">
                {{ $t("training.topic_agile") }}
              </li>

              <li class="mb-4">
                {{ $t("training.topic_estimation") }}
              </li>

              <li class="mb-4">
                {{ $t("training.topic_communication") }}
              </li>

              <li class="mb-4">
                {{ $t("training.topic_cv_presentation") }}
              </li>
            </ul>

            <p>
              <strong>{{ $t("training.backend") }}</strong>
            </p>

            <ul>
              <li class="mb-4">
                {{ $t("training.topic_databases") }}
              </li>

              <li class="mb-4">
                {{ $t("training.topic_devops") }}
              </li>

              <li class="mb-4">
                {{ $t("training.topic_php") }}
              </li>

              <li class="mb-4">
                {{ $t("training.topic_laravel") }}
              </li>

              <li class="mb-4">
                {{ $t("training.topic_dev_environments") }}
              </li>

              <li class="mb-4">
                {{ $t("training.topic_other_language") }}
              </li>
            </ul>

            <p>
              <strong>{{ $t("training.frontend") }}</strong>
            </p>

            <ul>
              <li class="mb-4">
                {{ $t("training.topic_javascript") }}
              </li>

              <li class="mb-4">
                {{ $t("training.topic_html_css") }}
              </li>

              <li class="mb-4">
                {{ $t("training.topic_vuejs") }}
              </li>

              <li class="mb-4">
                {{ $t("training.topic_state_management") }}
              </li>

              <li class="mb-4">
                {{ $t("training.topic_dev_environments") }}
              </li>

              <li class="mb-4">
                {{ $t("training.topic_frontend_tools") }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-lg-8 col-xl-5">
        <div class="im-col im-col-2">
          <div class="im-block">
            <h5>{{ $t("job.application_form_title") }}</h5>

            <div>
              <StatusMessage ref="statusMessageSuccess"></StatusMessage>

              <div ref="eleDirection" class="mb-3">
                <label for="jobApp_direction">{{ $t("job.direction") }}: *</label>
                <select
                  id="jobApp_direction"
                  v-model.trim="jobApp_direction"
                  class="form-control"
                  required
                >
                  <option value="">{{ $t("common.select_option") }}</option>
                  <option value="Frontend">Frontend</option>
                  <option value="Backend">Backend</option>
                  <option value="Full-stack">Full-stack</option>
                </select>
              </div>
              <StatusMessage ref="statusMessageDirection"></StatusMessage>

              <div ref="eleName" class="mb-3 required">
                <label for="jobApp_name">{{ $t("job.name") }}: *</label>
                <input
                  id="jobApp_name"
                  v-model.trim="jobApp_name"
                  type="text"
                  class="form-control"
                  :placeholder="$t('job.name_placeholder')"
                  required
                />
              </div>
              <StatusMessage ref="statusMessageName"></StatusMessage>

              <div ref="eleEmail" class="mb-3 required">
                <label for="jobApp_email">{{ $t("job.email") }}: *</label>
                <input
                  id="jobApp_email"
                  v-model.trim="jobApp_email"
                  type="email"
                  class="form-control"
                  placeholder="name@example.com"
                  required
                />
              </div>
              <StatusMessage ref="statusMessageEmail"></StatusMessage>

              <div ref="elePhone" class="mb-3">
                <label for="jobApp_phone">{{ $t("job.phone") }}: *</label>
                <input
                  id="jobApp_phone"
                  v-model.trim="jobApp_phone"
                  type="tel"
                  class="form-control"
                  placeholder="+359..."
                  required
                />
              </div>
              <StatusMessage ref="statusMessagePhone"></StatusMessage>

              <div ref="eleExpectations" class="mb-3 required">
                <label for="jobApp_expectations">{{ $t("job.expectations") }}: *</label>
                <textarea
                  id="jobApp_expectations"
                  v-model.trim="jobApp_expectations"
                  class="form-control"
                  rows="5"
                  required
                ></textarea>
              </div>
              <StatusMessage ref="statusMessageExpectations"></StatusMessage>

              <div ref="eleGitLink" class="mb-3">
                <label for="link">{{ $t("partnership.git_link") }}:</label>
                <input
                  id="link"
                  v-model.trim="jobApp_git"
                  type="url"
                  class="form-control"
                  placeholder="https://"
                />
              </div>
              <StatusMessage ref="statusMessageGitLink"></StatusMessage>

              <div class="mb-3 mb-0 required">
                <label>{{ $t("job.cv_formats") }} *</label>
              </div>

              <div class="input-group mb-3 required">
                <div class="custom-file">
                  <input
                    id="file"
                    ref="cvFile"
                    type="file"
                    required
                    @change="fileSetName($event)"
                  />
                  <label for="file" class="custom-file-label" v-text="file"></label>
                </div>
              </div>
              <StatusMessage ref="statusMessageFile"></StatusMessage>

              <div class="mb-3 text-sm-center">
                <re-captcha ref="recaptcha"></re-captcha>
              </div>
              <StatusMessage ref="statusMessageRobot"></StatusMessage>

              <button
                type="button"
                class="btn btn-primary btn-block"
                :class="{ disabled: submitDisabled }"
                @click="jobApp_Submit"
              >
                {{ $t("common.submit") }}
              </button>

              <StatusMessage ref="statusMessageSubmit"></StatusMessage>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import StatusMessage from "../shared/StatusMessage.vue";
  import ReCaptcha from "./ReCaptcha.vue";

  export default {
    name: "TrainingAndMentoringProgramSection",
    components: {
      StatusMessage,
      ReCaptcha,
    },
    data() {
      return {
        jobApp_direction: "",
        jobApp_name: "",
        jobApp_email: "",
        jobApp_phone: "",
        jobApp_expectations: "",
        jobApp_git: "",

        fileDefault: "Choose file",
        file: "",

        fileTypesAllowed: [
          "application/pdf", // pdf
          "application/vnd.oasis.opendocument.spreadsheet", // .ods
        ],

        submitDisabled: false,
      };
    },
    created() {
      this.fileDefault = this.$t("common.choose_file");
      this.file = this.fileDefault;
    },
    methods: {
      jobApp_Send(formData) {
        this.$root.request
          .post("/jobapplication/trainingandmentoringprogram", formData)
          .catch(this.$root.responseErrorHandler)
          .then(this.$root.responseMiddleware)
          .then((response) => {
            // console.dir(response);

            this.submitDisabled = false;

            if (response.success) {
              this.$root.scrollToTop();
              this.$refs.statusMessageSuccess.displaySuccessMessage("job_app_sent");
              this.resetForm();
            } else if (response.error && response.error.message) {
              this.$refs.statusMessageSubmit.displayErrorMessage(response.error.message);
            }
          });
      },
      jobApp_Submit() {
        if (this.jobApp_direction == "" || this.jobApp_direction.length < 5) {
          this.scrollTo("eleDirection");
          this.$refs.statusMessageDirection.displayErrorMessage("required", {
            attribute: this.$t("job.direction"),
          });
          return;
        }
        this.$refs.statusMessageDirection.resetStatusMessage();

        if (this.jobApp_name.length < 3) {
          this.scrollTo("eleName");
          this.$refs.statusMessageName.displayErrorMessage("required", {
            attribute: this.$t("job.name"),
          });
          return;
        }
        this.$refs.statusMessageName.resetStatusMessage();

        if (this.jobApp_email.length < 6) {
          this.scrollTo("eleEmail");
          this.$refs.statusMessageEmail.displayErrorMessage("required", {
            attribute: this.$t("job.email"),
          });
          return;
        }
        if (!this.$root.isEmailValid(this.jobApp_email)) {
          this.scrollTo("eleEmail");
          this.$refs.statusMessageEmail.displayErrorMessage("invalid_email");
          return;
        }
        this.$refs.statusMessageEmail.resetStatusMessage();

        if (this.jobApp_phone.length < 6) {
          this.scrollTo("elePhone");
          this.$refs.statusMessagePhone.displayErrorMessage("required", {
            attribute: this.$t("job.phone"),
          });
          return;
        }
        this.$refs.statusMessagePhone.resetStatusMessage();

        if (this.jobApp_expectations.length == 0) {
          this.scrollTo("eleExpectations");
          this.$refs.statusMessageExpectations.displayErrorMessage("required", {
            attribute: this.$t("job.expectations"),
          });
          return;
        }
        this.$refs.statusMessageExpectations.resetStatusMessage();

        // GitHub/BitBucket url
        if (this.jobApp_git.length > 0) {
          var isValidGitUrl = this.$root.isValidGitUrl(this.jobApp_git);
          if (!isValidGitUrl) {
            this.scrollTo("eleGitLink");
            this.$refs.statusMessageGitLink.displayErrorMessage("invalid_git_link");
            return;
          }
        }
        this.$refs.statusMessageGitLink.resetStatusMessage();

        // CV File
        if (this.$refs.cvFile.files.length == 0) {
          this.$refs.statusMessageFile.displayErrorMessage("required", {
            attribute: "CV",
          });
          return;
        }
        if (this.fileTypesAllowed.indexOf(this.$refs.cvFile.files[0].type) < 0) {
          this.$refs.statusMessageFile.displayErrorMessage("file");
          return;
        }

        // ReCaptcha
        if (
          typeof this.$refs.recaptcha.verifyKey !== "string" ||
          this.$refs.recaptcha.verifyKey.length < 200
        ) {
          this.$refs.recaptcha.resetRecaptcha();
          this.$refs.statusMessageRobot.displayErrorMessage("recaptcha");
          return;
        }
        this.$refs.statusMessageRobot.resetStatusMessage();

        // Form Data
        var uploadData = new FormData();
        uploadData.set("jobApp_app", this.jobApp_direction);
        uploadData.set("jobApp_name", this.jobApp_name);
        uploadData.set("jobApp_email", this.jobApp_email);
        uploadData.set("jobApp_phone", this.jobApp_phone);
        uploadData.set("jobApp_motivation", this.jobApp_expectations);
        uploadData.set("jobApp_git", this.jobApp_git);
        uploadData.set("jobApp_cv", this.$refs.cvFile.files[0]);
        uploadData.set("jobApp_recaptcha", this.$refs.recaptcha.verifyKey);

        this.submitDisabled = true;

        this.jobApp_Send(uploadData);
      },
      fileSetName(event) {
        if (event.target.files.length > 0) {
          if (this.fileTypesAllowed.indexOf(event.target.files[0].type) < 0) {
            this.file = this.fileDefault;
            this.$refs.statusMessageFile.displayErrorMessage("file");
          } else {
            this.file = event.target.files[0].name;
            this.$refs.statusMessageFile.resetStatusMessage();
          }
        } else {
          this.file = this.fileDefault;
          this.$refs.statusMessageFile.resetStatusMessage();
        }
      },
      scrollTo(refName) {
        this.$root.scrollTo(
          0,
          this.$refs[refName].offsetTop + this.$refs[refName].offsetParent.offsetTop
        );
      },
      resetFileInput() {
        this.$refs.cvFile.value = "";
        this.$refs.cvFile.type = "text";
        this.$refs.cvFile.type = "file";
      },
      resetForm() {
        this.jobApp_direction = "";
        this.jobApp_name = "";
        this.jobApp_email = "";
        this.jobApp_phone = "";
        this.jobApp_expectations = "";
        this.jobApp_git = "";

        // tricky reset of the file input field
        this.resetFileInput();

        this.$refs.recaptcha.resetRecaptcha();

        this.file = this.fileDefault;
      },
    },
  };
</script>
